import React from 'react'

export default function TextArea(props) {
    return (
        <textarea className="w-full border px-3 py-2  border-gray-300 rounded-md shadow-sm focus:outline-none text-sm" {...props} />
    )
}
